/**
 * Logs `[FirebaseAuth]` (sin token ni datos sensibles).
 * Activar solo cuando haga falta: `VUE_APP_FIREBASE_DEBUG=TRUE` en `.env` (reiniciar `serve`).
 */
const DEBUG_FIREBASE =
  process.env.VUE_APP_FIREBASE_DEBUG === 'TRUE' ||
  process.env.VUE_APP_FIREBASE_DEBUG === 'true'

export function isFirebaseDebug () {
  return DEBUG_FIREBASE
}

export function firebaseLog (step, detail) {
  if (!DEBUG_FIREBASE) return
  const d = detail !== undefined && detail !== null ? detail : ''
  // eslint-disable-next-line no-console
  console.log('[FirebaseAuth]', step, d)
}

/** Siempre a consola: fallos de login (Chrome inspect / logcat WebView). */
export function firebaseError (step, detail) {
  const d = detail !== undefined && detail !== null ? detail : ''
  // eslint-disable-next-line no-console
  console.error('[FirebaseAuth]', step, d)
}

export function serializeAuthError (e) {
  if (e == null) return { code: 'unknown', message: 'Error desconocido' }
  if (typeof e === 'string') return { code: 'unknown', message: e }
  const code = e.code != null ? String(e.code) : (e.errorCode != null ? String(e.errorCode) : 'unknown')
  const message = e.message || e.errorMessage || e.error || String(e)
  return { code, message }
}
